import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LoginModal } from './login-modal/login-modal';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { WindowService } from '../../providers/window/window.service';
import { MainContentClass } from '../../helpers/main-content.service.class';
import { ApiService } from '../../helpers/api.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  //standalone: true,
  //imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent extends MainContentClass {
  formG!: FormGroup;

  //title: string = "hola";

  constructor(
    router: Router, route: ActivatedRoute,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) platformId: Object,
    public fb: FormBuilder,
    genericService: ApiService, 
    private windowService: WindowService,
    private title: Title,
    private meta: Meta,
  ) {
    super(router, route,genericService,dialog ,platformId);
    this.formG = this.fb.group({
      idPais: ['',],
    });


  }

  ngOnInit(): void {
    this.hideLoader();
    this.title.setTitle('App de Seguridad por GPS | Geovype');
    this.meta.addTags([
      { name: 'description', content: 'Geovype es tu app de seguridad con GPS, control parental y más.' },
      { name: 'keywords', content: 'app de seguridad, gps, control parental, rastreo, geolocalización, protección' },
      { property: 'og:title', content: 'Geovype - Seguridad en tus manos' },
      { property: 'og:description', content: 'App de seguridad, control parental, alertas GPS y mucho más.' },
      { property: 'og:image', content: 'https://geovype.com/assets/og-image.jpg' },
      { property: 'og:url', content: 'https://geovype.com/' }
    ]);
  }

  ngAfterViewInit(): void {
    this.executeScroll();
    this.execButtonTopEvent();
    this.executeHoverEvent();
  }

  // execSpinner(): void {
  //   const spinner = () => {
  //     if (isPlatformBrowser(this.platformId)) {
  //       setTimeout(() => {
  //         const spinnerElement = document.querySelector('#spinner');
  //         if (spinnerElement) {
  //           spinnerElement.classList.remove('show');
  //         }
  //       }, 1);
  //     }
  //   };

  //   spinner();
  // }

  executeScroll(): void {
    const win = this.windowService.nativeWindow;
    if(win) {
      win.addEventListener('scroll', () => {
        const navbar = document.querySelector('.navbar');
        if (!navbar) return;
  
        if (win.scrollY > 45) {
          navbar.classList.add('sticky-top', 'shadow-sm');
        } else {
          navbar.classList.remove('sticky-top', 'shadow-sm');
        }
      });
    }
  }

  executeHoverEvent(): void {
    if (typeof document !== 'undefined' && document) {
      const showClass = 'show';
      const dropdowns = document.querySelectorAll('.dropdown');

      function toggleDropdownOnHover(enable: boolean) {
        dropdowns.forEach((dropdown) => {
          const toggle = dropdown.querySelector('.dropdown-toggle');
          const menu = dropdown.querySelector('.dropdown-menu');

          if (!toggle || !menu) return;

          if (enable) {
            dropdown.addEventListener('mouseenter', () => {
              dropdown.classList.add(showClass);
              toggle.setAttribute('aria-expanded', 'true');
              menu.classList.add(showClass);
            });

            dropdown.addEventListener('mouseleave', () => {
              dropdown.classList.remove(showClass);
              toggle.setAttribute('aria-expanded', 'false');
              menu.classList.remove(showClass);
            });
          } else {
            dropdown.replaceWith(dropdown.cloneNode(true)); // elimina listeners
          }
        });

      }
      
    }



    // window.addEventListener('load', checkScreenWidth);
    // window.addEventListener('resize', checkScreenWidth);
  }

  execButtonTopEvent(): void {
    if (typeof document !== 'undefined' && document) {
      const backToTopBtn = document.querySelector('.back-to-top');

      // window.addEventListener('scroll', () => {
      //   if (!backToTopBtn) return;

      //   if (window.scrollY > 100) {
      //     backToTopBtn.classList.add('visible');
      //   } else {
      //     backToTopBtn.classList.remove('visible');
      //   }
      // });

      const win = this.windowService.nativeWindow;
      if(win) {
        if (backToTopBtn) {
          backToTopBtn.addEventListener('click', (e) => {
            e.preventDefault();
            win.scrollTo({ top: 0, behavior: 'smooth' });
          });
        }
      }
    }
  }

  showModalLogin() {
    const dialogRef = this.dialog.open(LoginModal, {
      panelClass: 'custom-dialog-container',
      autoFocus: false,
      disableClose: true,
      hasBackdrop: true,
      width: "600px",
      height: "auto"
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        // 
      }
    });
  }
}
